import { render, staticRenderFns } from "./ObserverRefuse.vue?vue&type=template&id=26a2440e&scoped=true&"
import script from "./ObserverRefuse.vue?vue&type=script&lang=ts&"
export * from "./ObserverRefuse.vue?vue&type=script&lang=ts&"
import style0 from "./ObserverRefuse.vue?vue&type=style&index=0&id=26a2440e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a2440e",
  null
  
)

export default component.exports